import { useState, useCallback } from "react";

export type LaunchStatus = "idle" | "launching" | "launched" | "error";

interface UseLaunchAppOptions {
  /** If true, do NOT auto-reset status to "idle" after success/error (default: false) */
  persistStatus?: boolean;
}

export function useLaunchApp(onLaunch: () => Promise<void>, options?: UseLaunchAppOptions) {
  const [status, setStatus] = useState<LaunchStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const launch = useCallback(async () => {
    setStatus("launching");
    setError(null);
    try {
      await onLaunch();
      setStatus("launched");
      if (!options?.persistStatus) {
        setTimeout(() => setStatus("idle"), 3000);
      }
    } catch (err: unknown) {
      setStatus("error");
      setError(err instanceof Error ? err.message : "Unknown error");
      if (!options?.persistStatus) {
        setTimeout(() => setStatus("idle"), 3000);
      }
    }
  }, [onLaunch, options?.persistStatus]);

  return { status, launch, error };
}
